var Formatter = require('formatter');
var DialogView = require('dialogview');
var Keyboard = require('../lib/keyboard.es6').default;


var AccountMenuView = DialogView.extend({
    el: '.accountMenu',
    initialize: function (options, sidebar) {
        DialogView.prototype.initialize.call(this, options);
        
        this.sidebar = sidebar;
        
        this.showInstant = true;
        this.hideInstant = true;
        this.closeOnClickOff = true;
        
        this.formatter = new Formatter();
        this.model.bind('change:email change:name', this.renderLoggedInAs, this);
        this.model.bind('change:shard_id change:shard_name', this.renderShard, this);
        
        $('.accountMenu__button').on('click buttonClick', _.bind(this.clickAccountMenuButton, this));
    },
    events: $.extend({}, DialogView.prototype.events, {
        'buttonClick .accountMenu__invites-button': 'clickInvites',
        'buttonClick .accountMenu__signout-button': 'clickSignout'
    }),
    clickAccountMenuButton: function (e, options) {
        options = options || {};
        if (this.isVisible()) {
            this.hide();
            $('.accountMenu__button').attr('aria-expanded', 'false');
        } else {
            this.isKeypress = e.originalEvent ? Keyboard.isClickEnter(e) : options.keypress;
            this.show();
            $('.accountMenu__button').attr('aria-expanded', 'true');
            this.el.scrollTop = this.el.scrollHeight;
        }
        return false;
    },
    clickInvites: function (e) {
        DialogView.closeCurrent();
        this.model.trigger('showInvites');
        return false;
    },
    clickSignout: function (e) {
        e.preventDefault();
        this.model.logout();
    },
    renderLoggedInAs: function () {
        $('.accountMenu__email').text(this.model.get('email') || '');
        $('.accountMenu__name').text(this.model.get('name') || '');
    },
    renderShard: function() {
        var shardMsg = 'Server name: ' + this.model.get('shard_name') +
                       '; Server id: ' + this.model.get('shard_id');
        $('.accountMenu__title').attr('title', shardMsg);
    },
    afterHide: function () {
        this.isKeypress = null;
    },
    afterShow: function () {
        this.focusFirstItem();
    },
    focusFirstItem: function () {
        if (this.isKeypress) {
            this.$('.addNetworkButton').focus();
        }
    }
});


module.exports = AccountMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/accountmenuview.js
// module id = TwDC
// module chunks = 1